import Star from '@/assets/icons/star.svg?react';

export function GlowingStars() {
  return (
    <>
      <Star className="animate-glow absolute top-60 right-10 -z-10" />
      <Star className="animate-glow absolute top-96 left-9 -z-10 delay-100" />
      <Star className="animate-glow absolute top-[374px] right-10 -z-10 delay-300" />
      <Star className="animate-glow absolute bottom-72 left-4 -z-10 delay-700" />
      <Star className="animate-glow absolute right-[73px] bottom-60 -z-10 delay-1000" />
      <Star className="animate-glow absolute right-40 bottom-52 -z-10 delay-500" />
    </>
  );
}
